// extracted by mini-css-extract-plugin
export default {"PrivacyButtonDiv":"LandingPage_PrivacyButtonDiv__46TDZ","PrivacyButtonDivSmall":"LandingPage_PrivacyButtonDivSmall__q3N34","PrivacyButton":"LandingPage_PrivacyButton__-Q7on"};